/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {

	// Remove empty P tags created by WP inside of Accordion and Orbit
	$('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
		  $(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  $(this).wrap("<div class='responsive-embed'/>");
		}
	});

	$('.variation select').select2({
		minimumResultsForSearch: -1
	});

	// Mobile Menu
	$('.menu-icon, .mobile-brew-toggle-trigger').click(function(){
		if (!($(this).hasClass('brew-toggle-icon'))) {
			$(this).toggleClass('open');
		}
		$('body').toggleClass('mobile-nav-open');
	});

	$('.related-products-grid').slick({
	  dots: false,
	  infinite: true,
	  speed: 300,
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  mobileFirst: true,
	  arrows: true,
	  nextArrow: '<button type="button" class="slick-next"><i class="material-icons">keyboard_arrow_right</i></button>',
	  prevArrow: '<button type="button" class="slick-prev"><i class="material-icons">keyboard_arrow_left</i></button>',
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				},
			},
			{
				breakpoint: 1024,
				settings: "unslick"
			}
		]
	});

	$('.horizontal-brew-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		mobileFirst: true,
		nextArrow: '<button type="button" class="slick-next"><i class="material-icons">keyboard_arrow_right</i></button>',
		prevArrow: '<button type="button" class="slick-prev"><i class="material-icons">keyboard_arrow_left</i></button>',
		responsive: [
			{
				breakpoint: 550,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
				},
			}
		]
	});

	$('*[data-open-accordion]').click(function() {
		$('#product-form-accordion').foundation('down', $('#'+$(this).attr('data-open-accordion')));
		$(this).hide();
	});


});
